import './style.scss';

import React from 'react';
import AuthPageContainer from './container';
import SignupWithPromo from '../login/signupWithPromo';

class SignupPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { postSignup: false };
  }

  handlePostSignup() {
    this.setState({ postSignup: true });
  }

  render() {
    const promo =
      (this.props.match &&
        this.props.match.params &&
        this.props.match.params.promo) ||
      '';

    return (
      <AuthPageContainer
        renderNav={() =>
          !this.state.postSignup && (
            <a
              href="/login"
              className="btn-link btn-small signup-page__header-btn"
            >
              Log In
            </a>
          )}
        renderFooter={() =>
          !this.state.postSignup && (
            <div className="signup-page__form-footer">
              <small>
                Already have an account?{' '}
                <a href="/login" className="link-text">
                  Log in
                </a>.
              </small>
            </div>
          )}
      >
        <SignupWithPromo
          promo={promo}
          onPostSignup={() => this.handlePostSignup()}
        />
      </AuthPageContainer>
    );
  }
}

export default SignupPage;



// WEBPACK FOOTER //
// ./shared/components/authPages/signup.js